<template>
  <div class="row">
    <div class="col-md-12">
      <template v-if="media.sm">
        <el-descriptions :column="1" border direction="vertical">
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            <span data-cy="affiliation-idcard">{{ idcard | rutFormat }}</span>
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            <span data-cy="affiliation-fullname">{{ fullname }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'file-download']"></font-awesome-icon>
              Certificado de Afiliación
            </template>

            <template v-if="document !== null">
              <el-link type="warning" @click="downloadFiles">Descargar certificado.
                <em class="el-icon-download el-icon--right"></em>
              </el-link>
            </template>
            <template v-else>
              No se pudo obtener el certificado de afiliación.
            </template>

          </el-descriptions-item>


          <el-descriptions-item content-class-name="pp-el-descriptions-item"
                                v-if="state !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="estadoTag(stateCode)" data-cy="affiliation-state">{{ state }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>
      <template v-else>
        <el-descriptions :column="4" border>
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            <span data-cy="affiliation-idcard">{{ idcard | rutFormat }}</span>
          </el-descriptions-item>
          <el-descriptions-item span="3" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            <span data-cy="affiliation-fullname">{{ fullname }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'file-download']"></font-awesome-icon>
              Certificado de Afiliación
            </template>

            <template v-if="document !== null">
              <el-link type="warning" @click="downloadFiles">Descargar certificado.
                <em class="el-icon-download el-icon--right"></em>
              </el-link>
            </template>
            <template v-else>
              No se pudo obtener el certificado de afiliación.
            </template>

          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item"
                                v-if="state !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="estadoTag(stateCode)" data-cy="affiliation-state">{{ state }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>

    </div>
  </div>
</template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {Descriptions, DescriptionsItem, Link, Tag} from "element-ui";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";
import moment from "moment";

export default {
  name: "GenCertificadoDetail",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tag.name]: Tag,
    [Link.name]: Link,
  },
  props: {
    idcard: {
      type: String,
      required: true
    },
    fullname: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: false,
      default: null
    },
    stateCode: {
      type: Number,
      required: false,
      default: 0
    },
    document: {
      type: String,
      required: false,
      default: null
    }
  },
  mixins: [
    ScreenSizeMixin,
    ActividadCiudadanoEstadoMixin
  ],
  methods: {
    downloadFiles() {
      const data = this.document
      let link = document.createElement('a')
      link.href = data
      const date = moment().format('YYYYMMDDhhmmss')
      link.download = `certificado-afiliacion-${date}`
      link.click();
    },
  }
}
</script>

<style lang="scss">
.pp-el-descriptions-item {
  padding: 22px 10px !important;
}
</style>
